export const Book = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 52 65">
            <path d="M51.71 44.992V4.603A3.728 3.728 0 0 0 47.984.875H10.08C4.59.875.138 5.326.138 10.817v44.116c0-5.49 4.452-9.941 9.942-9.941z" />
            <path
                d="M51.71 52.137V44.99H10.08c-5.49 0-9.942 4.451-9.942 9.942s4.451 9.942 9.942 9.942h37.903a3.728 3.728 0 0 0 3.728-3.728v-3.417H12.817a2.796 2.796 0 0 1-.132-5.59l.132-.002z"
                opacity=".5"
            />
        </svg>
    );
};
